import {FinancialIO} from "ui-io/company-io"
import fetchApi from "../fetch-api";
import * as t from 'io-ts'

export const getFinancialsById = (props: {companyID:string|undefined}) => {
	return {
		queryKey: ["FINANCIALS_BY_ID", props.companyID],
		queryFn: () =>
			fetchApi({
				service:"admin-service",
				headers:{method: 'GET'},
				pathname: `/financials?companyID=${ props.companyID}`,
				codec: t.array(FinancialIO)
			})
	};
};
